import request from '../request'

export const getPeriodicalReportMarkingById = (periodicalReportId, params) =>
  request.get(`/periodical-report/marking/${periodicalReportId}`, { params }).then((res) => res)

export const updatePeriodicalReportMarkingById = (periodicalReportId, data) =>
  request.put(`/periodical-report/marking/${periodicalReportId}`, data).then((res) => res)

export const syncMarkingDataPeriodicalReportMarkingById = (periodicalReportId, data) =>
  request.post(`/periodical-report/marking/${periodicalReportId}/sync`, data).then((res) => res)

export const syncMarkingDataPeriodicalReportMarkingByIdAndAssessmentArea = (
  periodicalReportId,
  assessmentAreaId,
  data = {}
) =>
  request
    .post(`/periodical-report/marking/${periodicalReportId}/assessment-area/${assessmentAreaId}/sync`, data)
    .then((res) => res)

// MF-496 — Longitudinal periodical-report chart for one student (role-scoped in
// the backend). Returns { student, scale, bands, periods, subjects }.
export const getStudentPeriodicalReportChart = (studentId) =>
  request.get(`/periodical-report/marking/student-chart/${studentId}`).then((res) => res)
